import { defineStore } from 'pinia'
// import { ref } from 'vue'
// 你可以对 `defineStore()` 的返回值进行任意命名，但最好使用 store 的名字，同时以 `use` 开头且以 `Store` 结尾。(比如 `useUserStore`，`useCartStore`，`useProductStore`)
// 第一个参数是你的应用中 Store 的唯一 ID。
export const useResearch = defineStore('alert2', {
    // 其他配置...
    state: () => {
        return {
            research: {
                chooseSubject: '',
                contentMethod: '',
                contentViewpoint: '',
                expectedValue: '',
                baseResult: '',
                baseReference: '',
                conditionSubject: '',
                conditionEvaluate: '',
                conditionEnsure: '',
                conditionMaterialEquipment: '',
                conditionResearchMethod: '',
            },
        }
    },
    actions: {
        loadFormDataFromLocalStorage() {
            const storedData = JSON.parse(localStorage.getItem('research')) || {}
            this.research = { ...this.info, ...storedData }
        },
        saveFormDataToLocalStorage() {
            localStorage.setItem('research', JSON.stringify(this.research))
        },
        clearFormData() {
            localStorage.removeItem('research')
        },
    },
    persist: {
        enabled: true,
        strategies: [
            {
                key: 'research',
                storage: localStorage,
            },
        ],
    }

})